module.exports = __webpack_public_path__ + "static/media/courveShape.bf6924be.svg";